import { useCallback } from 'react';
import type { NumberContainerProps, NumberOwnProps } from './number';

function parseNumberInput(value: string) {
  if (value === '') return undefined;
  if (value.endsWith('.')) return value;
  const number = Number(value);
  if (Number.isNaN(number)) return value;
  return number;
}

export const useNumber = (props: NumberOwnProps): NumberContainerProps => {
  const { onChange, onBlur } = props;

  const handleChange: React.ChangeEventHandler<HTMLTextAreaElement | HTMLInputElement> = useCallback(
    (event) => {
      const { value } = event.target;
      onChange(parseNumberInput(value));
      onBlur();
    },
    [onBlur, onChange]
  );

  return { handleChange };
};
